export const tabsEventKey = {
  RATING_AND_REVIEW: 'ratings-reviews',
  SUPPORT: 'support',
  TECH_SPECS: 'tech-specs',
  PRODUCT_FORUM: 'product-forum',
  OVERVIEW: 'overview',
  COMPATIBLE_WITH: 'compatible-with',
  ACCESSORIES: 'accessories',
};
